export const INVOICE = 'regular'
export const CREDIT_INVOICE = 'credit'
